import { connect } from "react-redux";
import NhogsInteractiveLogo from "../components/NhogsInteractiveLogo";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(NhogsInteractiveLogo);
